import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { IPrivateRouteProps } from './types';
import { useAuthentication } from '../../authentiction';

const PrivateRoute: React.FC<IPrivateRouteProps> = ({
  component: Component,
  roles,
  ...rest
}) => {
  const { isAuthenticated, role } = useAuthentication();
  const location = useLocation();

  const isAuthorized = () => !roles || roles.indexOf(role) !== -1;

  return (
    <>
      {isAuthenticated && isAuthorized() ? (
        <Route {...rest} component={Component} />
      ) : (
        <Redirect
          to={{
            pathname: '/',
            state: { from: location },
          }}
        />
      )}
    </>
  );
};

export default PrivateRoute;
